<template>
  <div class="alert-container">
    <img class="logo" src="@/assets/svg/alert-success.svg" />
    <div style="height: 0px" class="form-group"></div>
    <div class="title"></div>

    <div class="form-group message" style="margin: 0">
      Mật khẩu đã được thay đổi. Vui lòng sử dụng mật khẩu mới để đăng nhập.
    </div>
    <div style="height: 0px" class="form-group"></div>
    <div class="form-group">
      <div class="row">
        <div class="btn btn-primary" @click="goHome('meeyland')">
          <img src="@/assets/logo/meeyland.svg" /> Meey Land
        </div>
        <div class="btn btn-primary" @click="goHome('meeymap')">
          <img src="@/assets/logo/meeymap.svg" /> Meey Map
        </div>
      </div>
      <div class="row">
        <div class="btn btn-primary" @click="goHome('meeycrm')">
          <img src="@/assets/logo/meeycrm.svg" /> Meey CRM
        </div>
        <div class="btn btn-primary" @click="goHome('meeyads')">
          <img src="@/assets/logo/meeyads.svg" /> Meey Ads
        </div>
      </div>
    </div>
    <div style="min-height: 30px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      target: null,
      errorMessage: null,
      error: {
        message: null,
        validates: [],
      },
    };
  },
  provide() {
    return { error: this.error };
  },

  created() {},
  methods: {
    goHome(home) {
      switch (home) {
        case "meeyland":
          location.href = process.env.VUE_APP_MEEY_LAND;
          break;
        case "meeymap":
          location.href = process.env.VUE_APP_MEEY_MAP;
          break;
        case "meeycrm":
          location.href = process.env.VUE_APP_MEEY_CRM;
          break;
        case "meeyads":
          location.href = process.env.VUE_APP_MEEY_ADS;
          break;
        default:
          this.$router.push("/login");
          break;
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.row {
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
  .btn {
    width: 48%;
  }
  .btn-primary {
    color: #2b2b2b;
    background: #f6f8fb;
    img {
      margin-right: 10px;
    }
  }
}
.alert-container {
  text-align: center;
  margin: auto;
  .title {
    text-align: center;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 10px;
    display: flex;

    .action {
      display: flex;
      width: 30px;
    }

    span {
      width: 100%;
      flex: 1;
    }
  }

  .logo {
    width: 80px;
  }

  .message {
    text-align: center;
    color: #626262;
    font-size: 20px;
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 500px) {
  .alert-container {
    width: 100%;
    margin: 0;
  }
}
.btn-primary{
  background: #f6f8fb !important;
}
</style>